module.exports = "/_next/static/images/instrument_7-f26d31e749613771ecf845de45640d08.png";